import { TranslationObject } from '@ngx-translate/core';
import { AspectRanking } from '@lib.core/entities/indicator/indicator-ranking';
import { AspectRankingComparison } from '@lib.core/entities/indicator/indicator-ranking-comparison';

export class AspectRankingComparisonDTO {
  location!: TranslationObject;
  value!: number;
  geoCode!: string;
  geoType!: string;

  static toAspectRankingComparison(comparisonDTO: AspectRankingComparisonDTO): AspectRankingComparison {
    const { location, value, geoCode, geoType } = comparisonDTO;
    return new AspectRankingComparison(location, value, geoCode, geoType);
  }
}

export class AspectRankingDTO {
  title!: TranslationObject;
  value!: number;
  rank!: number;
  compareWith!: string;
  comparisons!: AspectRankingComparisonDTO[];

  static toAspectRanking(aspectRankingDTO: AspectRankingDTO): AspectRanking {
    const { title, value, rank, compareWith, comparisons } = aspectRankingDTO;
    return new AspectRanking(
      title,
      value,
      rank,
      compareWith,
      comparisons.map(comparisonDTO => {
        return AspectRankingComparisonDTO.toAspectRankingComparison(comparisonDTO);
      })
    );
  }
}
